/**
 * @generated SignedSource<<72a12d61a97d9d074bded6a782527f87>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentAppSettingsButtonFragment$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"ContentAppSetupModalFragment">;
  readonly " $fragmentType": "ContentAppSettingsButtonFragment";
};
export type ContentAppSettingsButtonFragment$key = {
  readonly " $data"?: ContentAppSettingsButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentAppSettingsButtonFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentAppSettingsButtonFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContentAppSetupModalFragment"
    }
  ],
  "type": "ProductApp",
  "abstractKey": null
};

(node as any).hash = "b9c694475c0e2f4923537e559669cc74";

export default node;
